import './checkbox.css';
import './radio.css';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//   Brand Colors

const senstarPrimaryBlue = '#0082BA';
//const senstarPrimaryGrey = '#97999B';
const senstarPrimaryBlack = '#2C2A29';

// const senstarSecondaryDarkBlue = '#005670';
// const senstarSecondaryLightBlue = '#59CBE8';
// const senstarSecondaryYellow = '#FFB81C';
// const senstarSecondaryOrange = '#CC8A00';
// const senstarSecondaryRed = '#7C2529';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//   Other Colors

const borderColor = 'rgba(255,255,255,.1)';
const activeBorderColor = 'rgba(255,255,255,.5)';
const activeBorderShadowColor = 'rgba(255,255,255,.25)';
const splitterDividerColor = 'rgba(255,255,255,.025)';
const primaryTextColor = '#fff';
const inputBackgroundColor = '#252525';
const highlightBackgroundColor = primaryTextColor;
const highlightForegroundColor = senstarPrimaryBlack;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//   Styles

export const styles = {
    Workspace: {
        backgroundColor: senstarPrimaryBlack,
        color: primaryTextColor,
    },
    Window: {
        backgroundColor: inputBackgroundColor,
        color: primaryTextColor,
    },

    Accent: {
        backgroundColor: senstarPrimaryBlue,
    },

    Bordered: {
        border: `solid 1px ${borderColor}`,
    },

    BorderedActive: {
        border: `solid 1px ${activeBorderColor}`,
        boxShadow: `0px 0px 3px 1px ${activeBorderShadowColor}`,
    },

    Button: {
        backgroundColor: 'transparent',
        color: primaryTextColor,
        border: `solid 1px ${senstarPrimaryBlue}`,
    },
    Button_Focus_After: {
        border: `dotted 1px ${primaryTextColor}`,
    },

    DatePicker: {
        ActiveDay: {
            backgroundColor: senstarPrimaryBlue,
            color: primaryTextColor,
        },
        DayNames: {
            borderBottom: `solid 1px ${borderColor}`,
        },
    },

    FillForeground: {
        fill: primaryTextColor,
    },
    FillInvertForeground: {
        fill: inputBackgroundColor,
    },

    Highlighted: {
        backgroundColor: highlightBackgroundColor,
        color: highlightForegroundColor,
    },

    Input: {
        backgroundColor: inputBackgroundColor,
        color: primaryTextColor,
        border: `solid 1px ${borderColor}`,
    },

    Section: {
    },
    SectionHeader: {
        backgroundColor: senstarPrimaryBlue,
        color: primaryTextColor,
    },

    Splitter: {
        backgroundColor: splitterDividerColor,
        padding: '1px',
    },

    Text: {
        color: primaryTextColor,
    },

    Timeline: {
        backgroundColor: 'transparent',
    },

    TimelineBar: {
        Alarm:          { fill: '#FF4500' },
        AccessDenied:   { fill: '#FFFF00' },
        AccessGranted:  { fill: '#FFFFFF' },
        AccessOther:    { fill: '#FF0000' },
        CameraDownload: { fill: '#008080' },
        Motion:         { fill: '#005670' },
        NoSignal:       { fill: '#231F20' },
        Stable:         { fill: '#5C5C5C' },
        Zoom:           { fill: '#59CBE8' },
    },

    TopBar: {
        backgroundColor: senstarPrimaryBlack,
    },
};


// WEBPACK FOOTER //
// ./src/ui/styles/oem/styles.ts